import { render } from "./EventCard.vue?vue&type=template&id=a6a31f96&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=a6a31f96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a6a31f96"

export default script